import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Popover, Input, Button, ButtonToolbar, Tooltip, OverlayTrigger} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, arrayItemField} from '../../core/redux/form'
import {autocompleteMatcher, displayPrediction, highlightPrediction, getPredictionAddress} from '../../core/google/places'
import extract from '../../core/extract'
import Icon from '../../core/components/Icon'
import TypeaheadInput, {matcher, multiMatcher} from '../../core/components/TypeaheadInput'
import LoaderButton from '../../core/components/LoaderButton'
import {USAGES, ReferenceLotCmd} from '../models'
import {REFERENCE_LOT_CMD_UPDATED, sendReferenceLotCmd, sendReferenceBuildingCmds, updateReferenceLotCmd} from '../actions'
import i18n from '../i18n'
import style from './ReferenceLotPopover.less'

function addressMultiMatcher(addresses) {
    const googleSource = autocompleteMatcher
    const addressSource = matcher({
        source: addresses,
        identify: (a) => a.number + ' ' + a.street + ' ' + a.city
    })

    return multiMatcher([addressSource, googleSource])
}

class ReferenceLotPopover extends Component {
    static displayName = 'ReferenceLotPopover'

    static propTypes = {
        addresses: PropTypes.array.isRequired,
        building: PropTypes.object,
        onHide: PropTypes.func.isRequired,
        onSubmit: PropTypes.func
    }

    static defaultProps = {
        onSubmit: () => {}
    }

    constructor(props) {
        super(props)

        this.state = {
            activeUsageGroup: Object.keys(USAGES)[0]
        }
    }

    componentWillMount() {
        const {addresses} = this.props

        const addressSource = addressMultiMatcher(addresses)
        this.setState({addressSource})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.addresses != this.props.addresses) {
            const {addresses} = nextProps

            const addressSource = addressMultiMatcher(addresses)
            this.setState({addressSource})
        }
    }

    _sendCmd() {
        const {dispatch, cmd, onSubmit, onHide} = this.props

        return dispatch(sendReferenceBuildingCmds(cmd.addresses)).then((action) => {
            return dispatch(updateReferenceLotCmd({addresses: action.addresses}))
        }).then(() => {
            return dispatch(sendReferenceLotCmd())
        }).then(() => {
            return onSubmit()
        }).then(() => {
            onHide()
        })
    }

    _selectUsageGroup(event, group) {
        event.preventDefault()
        this.setState({activeUsageGroup: group})
    }

    _addAddress(event) {
        const {form} = this.props
        const {typeahead} = this.refs

        event.preventDefault()

        form.addresses.add()
        typeahead.reset()
    }

    render() {
        const {dispatch, form, cmd, addresses, building, onHide, ...others} = this.props
        const {activeUsageGroup, addressSource} = this.state
        const {buildingInput} = this.refs

        const displayAddressTypeahead = (addressOrPrediction) => {
            if (addressOrPrediction.city) {
                const address = addressOrPrediction
                var text = address.number + ' ' + address.street + ' ' + address.city
                text = text + (address.building && (' - ' + i18n.addressBuilding + ' ' + address.building.label) || '')
                return text
            }
            return displayPrediction(addressOrPrediction)
        }

        const highlightAddressTypeahead = (addressOrPrediction) => {
            if (addressOrPrediction.city) {
                return null
            }
            return highlightPrediction(addressOrPrediction)
        }

        const addressTypeaheadField = (field) => {
            
            function onChange(addressOrPrediction) {
                if (addressOrPrediction.city) {
                    const address = {building: building, ...addressOrPrediction, uid: null}
                    field.onChange(address)
                    buildingInput.getInputDOMNode().focus()
                } else {
                    getPredictionAddress(addressOrPrediction, (predictionAddress) => {
                        const address = predictionAddress && {building: building, ...predictionAddress}
                        field.onChange(address)
                        buildingInput.getInputDOMNode().focus()
                    })
                }
            }

            return {...field, onChange}
        }

        const addressTypeaheadButton = () => {
            if (form.addresses.size() > 1) {
                return (
                    <Button
                        onClick={(e) => form.addresses.remove(e)} >
                        <Icon icon='minus' size='xs' />
                    </Button>
                )
            }
            return (
                <Button>
                    <Icon icon='plus' size='xs' />
                </Button>
            )
        }

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        const tooltip = (text) => (
            <Tooltip
                className='tooltip-primary'>
                {text}
            </Tooltip>
        )

        const tooltipInputAddon = (text) => (
            <OverlayTrigger
                placement='bottom'
                overlay={tooltip(text)}>
                <span className={style.info}>?</span>
            </OverlayTrigger>
        )

        return (
            <Popover
                title={i18n.newLot}
                {...others}>
                <div className={style.default}>
                    <div className={style.usageGroup}>
                        <Row>
                            <Col xsHidden sm={3}>
                                <h5>type</h5>
                            </Col>
                            <Col sm={9}>
                                <ul className={style.container}>
                                    {Object.keys(USAGES).map((group, index) => (
                                        <li
                                            key={index}
                                            className={cx({[style.active]: activeUsageGroup == group})}>
                                            <a
                                                href=''
                                                onClick={(e) => this._selectUsageGroup(e, group)}>
                                                <Icon
                                                    icon={group}
                                                    size='md'
                                                    active={activeUsageGroup == group} />
                                                <span>{extract(i18n.usageGroupEnum, group)}</span>
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </Col>
                        </Row>
                    </div>
                    <form className='form-horizontal'>
                        <Input
                            labelClassName='col-sm-3'
                            wrapperClassName='col-sm-9'
                            type='select'
                            name='usage'
                            label={requiredLabel(i18n.usage)}
                            {...form.usage()}>
                            <option value=''></option>
                            {USAGES[activeUsageGroup].map((usage, index) => (
                                <option
                                    key={index}
                                    value={usage}>
                                    {extract(i18n.usageEnum, usage)}
                                </option>
                            ))}
                        </Input>
                        <Input
                            labelClassName='col-sm-3'
                            wrapperClassName='col-sm-9'
                            type='text'
                            name='reference'
                            label={requiredLabel(i18n.reference)}
                            addonAfter={tooltipInputAddon(i18n.referenceInfo)}
                            {...form.ref()} />
                        <Input
                            labelClassName='col-sm-3'
                            wrapperClassName='col-sm-9'
                            type='text'
                            name='lotNumber'
                            label={requiredLabel(i18n.lotNumber)}
                            addonAfter={tooltipInputAddon(i18n.lotNumberInfo)}
                            {...form.lotNumber()} />
                    </form>
                    <h5>{i18n.address_es} <i>*</i></h5>
                    <ul className={style.addressGroup}>
                        {(form.addresses().value || []).slice(1).reverse().map((address, index) => (
                            <li key={index}>
                                <a
                                    href=''
                                    className={style.remove}
                                    onClick={(e) => form.addresses.remove(e, address)}>
                                    <Icon icon='minus' size='xs' />
                                </a>
                                <p>
                                    <span>{address.number}</span>
                                    <span> {address.street}</span>
                                    <span>, {address.zipCode}</span>
                                    <span> {address.city}</span>
                                </p>
                            </li>
                        ))}
                    </ul>
                    <form>
                        <Row>
                            <Col xs={4} sm={3}>
                                <Input
                                    type='text'
                                    name='gate'
                                    placeholder={i18n.addressEntrance}
                                    {...form.addresses.recipientSupplement.entrance()} />
                            </Col>
                            <Col xs={4} sm={9}>
                                <Input
                                    type='text'
                                    name='digicode'
                                    placeholder={i18n.addressDigicode}
                                    {...form.addresses.digicode()} />
                            </Col>
                            <Col xs={4} sm={3}>
                                <Input
                                    type='text'
                                    name='floor'
                                    placeholder={i18n.addressFloor}
                                    {...form.addresses.recipientSupplement.floor()} />
                            </Col>
                            <Col xs={4} sm={3}>
                                <Input
                                    type='text'
                                    name='unit'
                                    placeholder={i18n.addressUnit}
                                    {...form.addresses.recipientSupplement.unit()} />
                            </Col>
                            <Col xs={4} sm={3}>
                                <Input
                                    type='text'
                                    name='floor'
                                    placeholder={i18n.addressElevator}
                                    {...form.addresses.recipientSupplement.elevator()} />
                            </Col>
                            <Col xs={4} sm={3}>
                                <Input
                                    type='text'
                                    name='floor'
                                    placeholder={i18n.addressStaircase}
                                    {...form.addresses.recipientSupplement.staircase()} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <TypeaheadInput
                                    ref='typeahead'
                                    source={addressSource}
                                    display={displayAddressTypeahead}
                                    highlight={highlightAddressTypeahead}
                                    placeholder={i18n.addAddress}
                                    buttonAfter={addressTypeaheadButton()}
                                    {...addressTypeaheadField(arrayItemField(form.addresses()))} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={4} sm={3}>
                                <Input disabled
                                    type='text'
                                    name='number'
                                    placeholder={i18n.addressNumber}
                                    {...form.addresses.number()} />
                            </Col>
                            <Col xs={8} sm={9}>
                                <Input
                                    ref='buildingInput'
                                    type='text'
                                    name='building'
                                    placeholder={i18n.addressBuilding}
                                    disabled={form.addresses.building.uid().value != null}
                                    {...form.addresses.building.label()} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <Input disabled
                                    type='text'
                                    name='street'
                                    placeholder={i18n.addressStreet}
                                    {...form.addresses.street()} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={4} sm={3}>
                                <Input disabled
                                    type='text'
                                    name='zipCode'
                                    placeholder={i18n.addressZipCode}
                                    {...form.addresses.zipCode()} />
                            </Col>
                            <Col xs={8} sm={9}>
                                <Input disabled
                                    type='text'
                                    name='city'
                                    placeholder={i18n.addressCity}
                                    {...form.addresses.city()} />
                            </Col>
                        </Row>
                    </form>
                    <ButtonToolbar>
                        {form.addresses.isValid() && (
                            <Button
                                bsStyle='link'
                                onClick={(e) => this._addAddress(e)}>
                                <Icon icon='plus' size='xs' />
                                <span>{i18n.addAddress}</span>
                            </Button>
                        )}
                    </ButtonToolbar>
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.save}
                        </LoaderButton>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </div>        
            </Popover>
            
        )
    }
}

ReferenceLotPopover = connectForm({
    target: 'cmd',
    schema: ReferenceLotCmd.schema,
    action: REFERENCE_LOT_CMD_UPDATED
})(ReferenceLotPopover)

ReferenceLotPopover = connect((state) => ({
    cmd: state.patrimony.referenceLotCmd
}))(ReferenceLotPopover)

export default ReferenceLotPopover


// WEBPACK FOOTER //
// ./lib/patrimony/components/ReferenceLotPopover.js